// --- UNIVERSAL FIX FOR ELLA THEME (NO AR LOCALE NEEDED) ---
class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.abortController = new AbortController();
    this.setupEventListeners();
  }

  setupEventListeners() {
    if (this.input && this.input.form) {
      this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
      this.input.addEventListener('input', this.onChange.bind(this));
    }
  }

  getQuery() {
    return this.input ? this.input.value.trim() : '';
  }

  onFormSubmit(event) {
    if (!this.getQuery().length) event.preventDefault();
  }

  onChange() {
    const searchTerm = this.getQuery();
    if (!searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(/\s+/g, '-').toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    try { this.abortController.abort(); } catch (e) {}
    this.abortController = new AbortController();

    // ✅ Always use English endpoint since /ar doesn’t exist
    const apiUrl = `/en/search/suggest?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search&resources[type]=product,collection,page,article`;

    fetch(apiUrl, {
      signal: this.abortController.signal,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'text/html,*/*',
      },
    })
      .then(response => {
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        return response.text();
      })
      .then(text => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');
        const section = doc.querySelector('#shopify-section-predictive-search');
        const resultsMarkup = section ? section.innerHTML : '';

        if (!resultsMarkup.trim()) {
          this.predictiveSearchResults.innerHTML = '<div class="predictive-search__no-results">لا توجد نتائج مطابقة</div>';
          this.predictiveSearchResults.style.display = 'block';
          this.removeAttribute('results');
          return;
        }

        this.cachedResults[queryKey] = resultsMarkup;
        this.renderSearchResults(resultsMarkup);
      })
      .catch(error => {
        if (error.name === 'AbortError') return;
        console.error('[PredictiveSearch] fetch error:', error);
        this.predictiveSearchResults.innerHTML = '<div class="predictive-search__no-results">حدث خطأ أثناء جلب النتائج</div>';
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    if (!this.statusElement) return;
    this.statusElement.textContent = '...';
    this.setAttribute('loading', true);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);
    this.setAttribute('open', true);
    this.open();
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = '400px';
    this.setAttribute('open', true);
    if (this.input) this.input.setAttribute('aria-expanded', true);
  }

  close(clear = false) {
    if (clear && this.input) this.input.value = '';
    this.removeAttribute('results');
    this.removeAttribute('open');
    if (this.input) this.input.setAttribute('aria-expanded', false);
    this.predictiveSearchResults.innerHTML = '';
  }
}

customElements.define('predictive-search', PredictiveSearch);
// --- END FIX ---
